<form [formGroup]="partnerForm" novalidate>
  <div class="mock-step-two partner-inscription-step-address">
    <div class="mock-step-two-row mock-step-two-row--top">
      <div class="mock-step-two-field mock-step-two-field--cep">
        <div class="mock-step-two-cep-stack">
          <div class="partner-inscription-field partner-inscription-field--search-end">
            <umkt-custom-input
              formControlName="cep"
              [placeholder]="'pages.partnerRegistration.form.sections.address.cep.placeholder' | i18n"
              [floatingLabel]="true"
              mask="00000-000"
              [showSearchIcon]="true"
              [showClearButton]="false"
              (searchSubmit)="onCepSearchClick()"
            ></umkt-custom-input>
          </div>
          <a
            href="https://buscacepinter.correios.com.br/app/endereco/index.php"
            class="mock-step-two-cep-link"
            target="_blank"
            rel="noopener noreferrer"
          >{{ 'pages.partnerRegistration.form.sections.address.cep.link' | i18n }}</a>
        </div>
      </div>
      <div class="mock-step-two-field mock-step-two-field--endereco">
        <div class="partner-inscription-field">
          <umkt-custom-input
            formControlName="endereco"
            [placeholder]="'pages.partnerRegistration.form.sections.address.endereco.placeholder' | i18n"
            [floatingLabel]="true"
            [maxlength]="255"
            [showClearButton]="false"
          ></umkt-custom-input>
        </div>
      </div>
    </div>

    <div class="mock-step-two-row">
      <div class="mock-step-two-field mock-step-two-field--numero">
        <div class="partner-inscription-field">
          <umkt-custom-input
            formControlName="numero"
            [placeholder]="'pages.partnerRegistration.form.sections.address.numero.placeholder' | i18n"
            [floatingLabel]="true"
            [maxlength]="20"
            [showClearButton]="false"
          ></umkt-custom-input>
        </div>
      </div>
      <div class="mock-step-two-field mock-step-two-field--complemento">
        <div class="partner-inscription-field">
          <umkt-custom-input
            formControlName="complemento"
            [placeholder]="'pages.partnerRegistration.form.sections.address.complemento.placeholder' | i18n"
            [floatingLabel]="true"
            [maxlength]="255"
            [showClearButton]="false"
          ></umkt-custom-input>
        </div>
      </div>
    </div>

    <div class="mock-step-two-row">
      <div class="mock-step-two-field mock-step-two-field--estado">
        <select class="partner-inscription-select" formControlName="estado" [attr.aria-label]="'pages.partnerRegistration.form.sections.address.estado.label' | i18n">
          <option value="">{{ 'pages.partnerRegistration.form.sections.address.estado.placeholder' | i18n }}</option>
          <option *ngFor="let state of brazilStates" [value]="state.value">{{ state.value }}</option>
        </select>
      </div>
      <div class="mock-step-two-field mock-step-two-field--cidade">
        <div class="partner-inscription-field">
          <umkt-custom-input
            formControlName="cidade"
            [placeholder]="'pages.partnerRegistration.form.sections.address.cidade.placeholder' | i18n"
            [floatingLabel]="true"
            [maxlength]="100"
            [showClearButton]="false"
          ></umkt-custom-input>
        </div>
      </div>
      <div class="mock-step-two-field mock-step-two-field--bairro">
        <div class="partner-inscription-field">
          <umkt-custom-input
            formControlName="bairro"
            [placeholder]="'pages.partnerRegistration.form.sections.address.bairro.placeholder' | i18n"
            [floatingLabel]="true"
            [maxlength]="100"
            [showClearButton]="false"
          ></umkt-custom-input>
        </div>
      </div>
    </div>
  </div>
</form>
